<template>
  <div id="AssemblyDetail_main">
    <div
      v-loading="loading"
      class="main"
    >
      <div class="title_bar">
        <div class="left">
          <div class="title">
            檢視會議
          </div>
        </div>
        <div class="right">
          <el-button
            :disabled="data.status == 'Started'"
            plain
            @click="$router.push({name:'AssemblyEdit', query: { id: assemblyId }})"
          >
            編輯
          </el-button>
          <el-button
            plain
            @click="print()"
          >
            列印
          </el-button>
          <el-button
            :disabled="data.status !== 'Created'"
            type="primary"
            plain
            @click="publishAssembly()"
          >
            發佈
          </el-button>
          <el-button
            :disabled="data.status == 'Started'"
            type="danger"
            plain
            @click="deleteAssembly()"
          >
            刪除
          </el-button>
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="會議基本資料"
          name="1"
        >
          <el-form
            :model="data"
            label-position="left"
            label-width="118px"
          >
            <el-form-item
              label="會議名稱"
              class="title"
            >
              <p>{{ data.title }}</p>
            </el-form-item>
            <el-form-item label="會議類型">
              <el-radio
                v-model="data.category"
                label="Regular"
                disabled
              >
                定期
              </el-radio>
              <el-radio
                v-model="data.category"
                label="Extraordinary"
                disabled
              >
                臨時
              </el-radio>
            </el-form-item>
            <el-form-item
              v-if="data.assemblyStartAt"
              label="會議日期"
            >
              <span>{{ data.assemblyStartAt.slice(0, 10) }}</span>
            </el-form-item>
            <el-form-item
              v-if="data.assemblyStartAt"
              label="會議時間"
            >
              <span>{{ data.assemblyStartAt.slice(-8, -3) }}</span>
              <span v-if="data.assemblyDueAt && data.assemblyDueAt != `0001-01-01T00:00:00`"> ~ {{ data.assemblyDueAt.slice(-8, -3) }}</span>
            </el-form-item>
            <el-form-item
              v-if="data.place"
              label="會議地點"
            >
              <span>{{ data.place.name }}</span>
            </el-form-item>
            <el-form-item
              v-if="data.place"
              label="會議地址"
            >
              <span>{{ data.place.address }}</span>
            </el-form-item>
            <el-form-item label="發文字號">
              <span>{{ data.issueTextNumber }}</span>
            </el-form-item>
            <el-form-item
              v-if="data.host"
              label="會議召集人"
            >
              <el-radio-group
                v-model="data.host.role"
                disabled
              >
                <el-radio
                  v-for="(item,index) in hostOptions"
                  :key="index"
                  :label="item.label"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
              <p>{{ data.host.name }}</p>
            </el-form-item>
            <el-form-item
              v-if="data.contactPerson"
              label="聯絡人"
            >
              <div v-if="data.contactPerson.name === null" />
              <div v-else>
                <el-radio-group
                  v-model="data.contactPerson.role"
                  disabled
                >
                  <el-radio
                    v-for="(item, index) in contactPersonOptions"
                    :key="index"
                    :label="item.label"
                  >
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
                <p>{{ data.contactPerson.name }}</p>
              </div>
            </el-form-item>
            <el-form-item
              label="會議程序"
              class="description"
            >
              <template>
                <div v-html="data.cleanDescription" />
              </template>
            </el-form-item>
            <el-form-item label="備註">
              <div class="note">
                {{ data.note }}
              </div>
            </el-form-item>
          </el-form>
          <el-button
            round
            @click="$router.push({name:'UnitOwnerAssembly'})"
          >
            返回區權會會議列表
          </el-button>
          <el-button
            type="primary"
            round
            @click="nextPage('2')"
          >
            下一頁
          </el-button>
        </el-tab-pane>
        <el-tab-pane
          v-if="data.threshold"
          label="議案資料"
          name="2"
        >
          <div class="content">
            <div class="left">
              <span>報到統計規則</span>
            </div>
            <div class="right">
              <el-checkbox
                v-model="data.threshold.isTabletUsed"
                disabled
              >
                出席人數
              </el-checkbox>
              <el-checkbox
                v-model="data.threshold.isAreaUsed"
                disabled
              >
                區分所有權佔比
              </el-checkbox>
              <div
                v-if="data.threshold.isTabletUsed"
                class="num"
              >
                {{ threshold(data.threshold.tabletThreshold.threshold) }} ％
              </div>
              <div
                v-else
                class="num"
              >
                {{ threshold(data.threshold.areaThreshold.threshold) }} ％
              </div>
            </div>
          </div>
          <TopicList :topic-list="topicList" />
          <div class="btnControl">
            <el-button
              round
              @click="$router.push({name:'UnitOwnerAssembly'})"
            >
              返回區權會會議列表
            </el-button>
            <el-button
              type="primary"
              round
              @click="nextPage('1')"
            >
              上一頁
            </el-button>
            <el-button
              type="primary"
              round
              @click="nextPage('3')"
            >
              下一頁
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="區權戶資料"
          name="3"
        >
          <div class="content">
            <RegisterList
              :show-filter="false"
              :show-conrtol-wrap="false"
              :show-button="false"
              :display-mode="1"
              :show-registration="false"
            />
          </div>
          <div class="btnControl">
            <el-button
              round
              @click="$router.push({name:'UnitOwnerAssembly'})"
            >
              返回區權會會議列表
            </el-button>
            <el-button
              type="primary"
              round
              @click="nextPage('2')"
            >
              上一頁
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <PrintDialog ref="printDialog" />
  </div>
</template>
<script>
import * as DOMPurify from 'dompurify'
import TopicList from './components/TopicList'
import PrintDialog from './components/print/PrintDialog'
import RegisterList from './components/RegisterList'
export default {
  components: {
    PrintDialog,
    TopicList,
    RegisterList
  },
  data () {
    return {
      assemblyId: this.$route.params.id,
      activeName: '1',
      data: {},
      topicList: [],
      hostOptions: [ // 主席身份選項
        {
          name: '主任委員',
          label: 'Chairperson'
        }, {
          name: '起造人',
          label: 'Builder'
        }, {
          name: '其他',
          label: 'Others'
        }
      ],
      contactPersonOptions: [ // 聯絡人身份選項
        {
          name: '社區經理',
          label: 'Manager'
        }, {
          name: '管理員',
          label: 'Staff'
        }, {
          name: '委員',
          label: 'CommitteeMember'
        }, {
          name: '其他',
          label: 'Others'
        }
      ],
      files: [],
      loading: false,
      canClickButton: true
    }
  },
  mounted () {
    this.getAssembly()
    this.getTopicList()
  },
  methods: {
    // 取得會議資料
    getAssembly () {
      this.loading = true
      apiUnitOwnerAssembly.Assembly.GetAssembly(
        {
          AssemblyId: this.assemblyId
        }
      ).then(res => {
        console.log(res)
        this.data = res.data
        this.data.cleanDescription = DOMPurify.sanitize(this.data.description, { USE_PROFILES: { html: true } })
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 取得議案資料
    getTopicList () {
      this.loading = true
      apiUnitOwnerAssembly.Topic.GetTopicList(
        {
          AssemblyId: this.assemblyId
        }
      ).then(res => {
        console.log(res)
        this.topicList = res.data
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    print () {
      this.$refs.printDialog.openPrintDialogFromDetail(this.data, this.topicList)
    },
    nextPage (page) {
      this.activeName = page
      window.scrollTo(0, 0)
    },
    // 發佈會議
    publishAssembly () {
      this.$confirm('是否發佈此會議？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        if (this.canClickButton) {
          this.canClickButton = false
          apiUnitOwnerAssembly.Assembly.PublishAssembly(
            {
              assemblyId: this.assemblyId
            }
          ).then(res => {
            console.log(res)
            // eslint-disable-next-line eqeqeq
            if (res.status == 200) {
              this.$message({
                message: '此會議發佈成功！',
                type: 'success'
              })
              this.$router.push({ name: 'UnitOwnerAssembly' })
            }
            this.canClickButton = true
          }).catch((err) => {
            console.log('錯誤訊息：', err.response)
          })
        }
      }).catch(e => {})
    },
    // 刪除會議
    deleteAssembly () {
      this.$confirm('是否刪除此會議？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        if (this.canClickButton) {
          this.canClickButton = false
          console.log(this.assemblyId)
          apiUnitOwnerAssembly.Assembly.DeleteAssembly(
            {
              data: { assemblyId: this.assemblyId },
              'content-type': 'application/json'
            }
          ).then(res => {
            console.log(res)
            // eslint-disable-next-line eqeqeq
            if (res.status == 200) {
              this.$message({
                message: '會議刪除成功',
                type: 'success'
              })
              this.$router.push({ name: 'UnitOwnerAssembly' })
            }
            this.canClickButton = true
          }).catch((err) => {
            this.canClickButton = true
            console.log('錯誤訊息：', err.response)
          })
        }
      }).catch(e => {})
    },
    threshold (attendanceThreshold) {
      return parseFloat((attendanceThreshold * 100).toPrecision(12))
    }
  }
}
</script>
<style lang="sass" scoped>
#AssemblyDetail_main
  +mainLayer
  max-width: 1140px
  margin: 0 auto
  ::v-deep .el-tabs
    +basicTabs
  #pane-1
    margin-top: 10px
    ::v-deep .el-form
      +basicForm
      max-width: 70%
      margin: 0 auto
      text-align: left
      .el-form-item__label
        line-height: 40px
        margin-right: 0px
      .el-form-item__content
        line-height: 40px
        span
          word-wrap: break-word
        .note
          word-wrap: break-word
          white-space: break-spaces
          width: 100%
      .title
        .el-form-item__content
          p
            width: 100%
            word-wrap: break-word
            font-size: 18px
            font-weight: bold
      .description
        > .el-form-item__content
          line-height: initial
          width: 100%
          overflow: auto
          > div
            width: 100%
            p
              width: 100%
              word-wrap: break-word
  #pane-2
    margin-top: 10px
    width: 100%
    .content
      width: 70%
      margin: 0 auto 20px
      display: flex
      .left
        width: 130px
        text-align: left
        position: relative
        line-height: 42px
      .right
        color: $subFontColor
      .el-checkbox
        line-height: 42px
      ::v-deep .el-input-number.inputnum
        width: 80px
        margin-left: 20px
        .el-input-number__decrease,.el-input-number__increase
          display: none
        .el-input
          .el-input__inner
            font-weight: bold
            font-size: 18px
            letter-spacing: 2px
            padding-right: 0
            padding-left: 0
            color: $subFontColor
      div.num
        display: inline-block
        font-size: 18px
        letter-spacing: 2px
        color: $subFontColor
        font-weight: bold
        line-height: 40px
        margin-left: 10px
  #pane-3
    ::v-deep .file-tip
      display: none
    ::v-deep .file
      margin: 10px auto
  .btnControl
    margin-top: 30px
</style>
